import { Link } from "react-router-dom";
import { AlertCircle, FlaskConical, ArrowRight } from "lucide-react";
import { ModuleLayout } from "../_shared/ModuleLayout";

function LegacyBanner() {
  return (
    <div
      className="mb-4 px-4 py-3 rounded flex items-start gap-3"
      style={{
        background: "linear-gradient(90deg, rgba(176,141,61,0.10), rgba(139,110,40,0.06))",
        border: "1px solid rgba(176,141,61,0.35)",
      }}
      data-testid="rd-legacy-banner"
    >
      <AlertCircle size={16} className="mt-0.5 shrink-0" style={{ color: "#8B6E28" }} />
      <div className="flex-1 text-xs">
        <div className="font-semibold text-slate-900">
          Legacy R&D workspace · Uses demo data · Not linked to Product Master
        </div>
        <div className="mt-0.5 text-slate-600">
          The new <b>R&D Laboratory</b> replaces this workspace. It is bound to Product Master,
          uses the Raw Materials Library and enforces the approve-cascade contract.
        </div>
      </div>
      <Link
        to="/pureh/rd-lab"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-semibold shrink-0 transition hover:opacity-90"
        style={{ background: "#25230F", color: "#F7F3EB" }}
        data-testid="rd-legacy-banner-cta"
      >
        <FlaskConical size={12} /> Open R&D Laboratory <ArrowRight size={12} />
      </Link>
    </div>
  );
}

export default function RndLayout() {
  return (
    <div>
      <div className="px-6 pt-6">
        <LegacyBanner />
      </div>
      <ModuleLayout
        testId="pureh-rd"
        eyebrow="R&D · Studio (Legacy)"
        title="R&D Operating System"
        subtitle="Legacy mock module · Superseded by R&D Laboratory (Workstream 03)"
        tabs={[
          { to: "library",   label: "Product Library" },
          { to: "workspace", label: "R&D Bench" },
          { to: "formulas",  label: "Formula Manager" },
          { to: "materials", label: "Raw Materials" },
          { to: "suppliers", label: "Suppliers" },
          { to: "lab",       label: "Lab Sessions" },
          { to: "sampling",  label: "Sampling" },
          { to: "blind",     label: "Blind Testing" },
          { to: "decisions", label: "Decisions" },
          { to: "timeline",  label: "Timeline" },
        ]}
      />
    </div>
  );
}
